module.exports = __webpack_public_path__ + "media/images/bg-mv-feather-3a2b4be81e88f4c0dfba66245a0a77de.png";